import ky from "ky";

function getCsrfToken() {
  return document.querySelector('meta[name="csrf-token"]')?.content ?? "";
}

const api = ky.create({
  prefixUrl: "/api/v1",
  credentials: "include",
  hooks: {
    beforeRequest: [
      (request) => {
        request.headers.set("X-CSRF-Token", getCsrfToken());
        request.headers.set("Content-Type", "application/json");
        request.headers.set("Accept", "application/json");
      },
    ],
  },
});

export default api;
